import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { GoalType } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class GoalTypesService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getAll(): Observable<GoalType[]> {
        return this.http.get<GoalType[]>(
            `${this.config.getConfiguration().API_BASE}/goaltype`,
            {},
        );
    }
}
